import storeConfig from 'Stores/ceika-performance-store/config';

try {
  storeConfig.InitFunc?.();
} catch (e) {
  console.error(e);
  import('Diagnostics/diagnostics')
    .then(({ logRuntimeError }) => logRuntimeError({ source: 'init_func', error: e }))
    .catch(() => {});
}
